'use client'

import type { Editor } from '@tiptap/react'
import { EditorContent } from '@tiptap/react'

import { cn } from '@/lib/utils'

export interface EditorContentAreaProps {
  editor: Editor | null
  minHeight: string
  maxHeight: string
}

const editorContentClasses = cn(
  'h-full',
  '[&_.is-editor-empty:first-child]:before:pointer-events-none',
  '[&_.is-editor-empty:first-child]:before:float-left',
  '[&_.is-editor-empty:first-child]:before:h-0',
  '[&_.is-editor-empty:first-child]:before:text-muted-foreground',
  '[&_.is-editor-empty:first-child]:before:content-[attr(data-placeholder)]'
)

/**
 * Wrapper for the TipTap editor content area with placeholder styling
 */
export const EditorContentArea = ({ editor, minHeight, maxHeight }: EditorContentAreaProps) => (
  <div
    className="relative overflow-auto text-foreground"
    style={{
      minHeight,
      maxHeight: maxHeight !== 'none' ? maxHeight : undefined,
    }}
  >
    <EditorContent editor={editor} className={editorContentClasses} />
  </div>
)

EditorContentArea.displayName = 'EditorContentArea'
